
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lng]/warranty-activation/embed",
      function () {
        return require("private-next-pages/[lng]/warranty-activation/embed/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lng]/warranty-activation/embed"])
      });
    }
  